const removeTrailingZeroes = (s: string): string => {
    return s.replace(/\.?0+$/, '')
}

export const formatPercentage = (
    percentage: number,
    opts?: { representedAs: 'fraction' | 'decimal' },
): string => {
    const multiplier = opts?.representedAs === 'fraction' ? 100 : 1
    const s = removeTrailingZeroes((percentage * multiplier).toFixed(3))
    return s + '%'
}
